import React from "react";
import { Box, Typography } from "@material-ui/core";
import { MessageOutlined } from "@material-ui/icons";
import useStyles from "./styles";

const NoComment = () => {
  const classes = useStyles();
  return (
    <Box
      p={{ xs: 1, md: 3 }}
      textAlign="center"
      height="100%"
      display="flex"
      flexDirection="column"
      // justifyContent="center"
      alignItems="center">
      <span className={classes.msgIcon}>
        <MessageOutlined fontSize="large" />
      </span>
      <Typography variant="body2">Your future is looking bright!</Typography>
      <Typography variant="body2" className="f-light-gray font-12">
        Share your thoughts about this vision below
      </Typography>
    </Box>
  );
};
export default NoComment;
